import React from 'react';
import PageNavControls from 'components/PageNavControls';
import { IProps, IState } from './types';
import { PrizeWinnerContent, WinnerContent } from 'bff/models/promotion';
import { RouterSettings } from 'constants/models/routerSettings';
// import moment from 'moment';
import moment from 'moment-timezone';
import _ from 'lodash';
import promotionListService from 'bff/services/promotionListService';
import commonService from 'utils/commonService';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import { PromotionSectionType } from 'constants/enums/promotionType.enum';
import PromotionTypeDefines from 'constants/models/promotionTypeDefines';

class PromotionsAnnouncement extends React.Component<IProps, IState> {
  componentDidMount = async () => {
    // 頁面初始取得傳入的得獎公告內容
    let prizeWinnerSn = storageService.getItem(storageKeys.PrizeWinnerSn);

    storageService.removeItem(storageKeys.PrizeWinnerSn);

    if (!storageService.getItem(storageKeys.PromotionDetail) && !prizeWinnerSn) {
      this.props.history.push(RouterSettings.Promotions.List);
      return;
    }

    let prePromotionTitle = PromotionTypeDefines[PromotionSectionType.PrizeWinner];
    if (this.props.history.location.state) {
      const { promotionType }: any = this.props.history.location.state;
      if (promotionType) {
        prePromotionTitle = PromotionTypeDefines[promotionType as PromotionSectionType];
      }
    }

    if (prizeWinnerSn) {
      prizeWinnerSn = Number.parseInt(prizeWinnerSn);
      const prizeWinnerInfo = await promotionListService.fetchPrizeWinnerInfo(prizeWinnerSn);
      if (!prizeWinnerInfo) return;
      prePromotionTitle = PromotionTypeDefines[PromotionSectionType.PrizeWinner];
      this.setState({ prizeWinnerInfo: prizeWinnerInfo, prePromotionTitle: prePromotionTitle });
      return;
    }

    const prizeWinnerInfo = JSON.parse(storageService.getItem(storageKeys.PromotionDetail)) as PrizeWinnerContent;

    this.setState({ prizeWinnerInfo: prizeWinnerInfo, prePromotionTitle: prePromotionTitle });
  }

  componentDidUpdate() {
    // 內容資料有更動，移至畫面上方
    commonService.scrollToTop();
  }

  componentWillUnmount() {
    // 頁面關閉，暫存明細資料
    storageService.removeItem(storageKeys.PromotionDetail);
    storageService.setItem(storageKeys.PromotionDetail, JSON.stringify(this.state.prizeWinnerInfo));

    // 頁面關閉更新暫存的優惠列表資訊，設定使用區塊為對應區塊
    if (storageService.getItem(storageKeys.TempInfo)) {
      let tempInfo = JSON.parse(storageService.getItem(storageKeys.TempInfo));
      storageService.removeItem(storageKeys.TempInfo);

      tempInfo = {
        ...tempInfo,
        activeTab: PromotionSectionType.PrizeWinner
      };

      storageService.setItem(storageKeys.TempInfo, JSON.stringify(tempInfo));
    }
  }

  render() {
    /**
   * @description 建立得獎資訊區塊
  */
    const handleCreatePrizeArea = (prizeWinnerInfo: PrizeWinnerContent) => {
      const thead = new Array(0);

      const header = ['獎項', '中獎人', '保單號碼或身份證字號'];

      const child = _.map(header, (str: string, index: number) => {
        return <th key={index} className="element__table-horizon-x-title">{str}</th>;
      });

      thead.push(React.cloneElement(
        <tr>
          {child}
        </tr>
        , { key: thead.length + 1 }));

      const content = _.map(prizeWinnerInfo.WINNERS, (winner: WinnerContent, index: number) => {
        return (
          <tr key={index}>
            <th className="element__table-horizon-y-title">{winner.ITEM_NAME}</th>
            <td>{winner.ITEM_WINNER}</td>
            <td>{winner.PNO_IDNO}</td>
          </tr>
        );
      });

      return (
        <>
          {thead}
          {content}
        </>
      );
    };

    /**
 * @description 點選上下一則的事件
*/
    const handleNextPrevClick = async (sn: number) => {
      if (!sn) return;
      const prizeWinnerInfo = await promotionListService.fetchPrizeWinnerInfo(sn);
      if (!prizeWinnerInfo) return;

      storageService.removeItem(storageKeys.PromotionDetail);
      storageService.setItem(storageKeys.PromotionDetail, JSON.stringify(prizeWinnerInfo));
      this.setState({ prizeWinnerInfo: prizeWinnerInfo });
    };

    return this.state && this.state.prizeWinnerInfo && (
      <div className="promotions-announcement">
        <div className="template-container">
          <div className="template-content">
            {/* 活動資訊 */}
            <div className="activity-info">
              <div className="activity-info__header">
                <div className="activity-info__period">
                  <span>{`活動日期：${moment(this.state.prizeWinnerInfo.START_DATE).format('YYYY/MM/DD')} ~ ${moment(this.state.prizeWinnerInfo.END_DATE).format('YYYY/MM/DD')}`}</span>
                </div>
                <div className="activity-info__title">{this.state.prizeWinnerInfo.TITLE}</div>
              </div>
              <div className="activity-info__main">
                <div
                  className="activity-info__main-cover-photo"
                  style={{
                    backgroundImage: `url(${this.state.prizeWinnerInfo.IMAGE_URL})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                  }}
                />
                <div className="activity-info__main-content">
                  <div className="activity-info__main-title">活動來源 : {this.state.prizeWinnerInfo.SUBTITLE}</div>
                  <div className="activity-info__main-desc">
                    <p>{commonService.htmlParser(this.state.prizeWinnerInfo.EVENT_DESC)}</p>
                  </div>
                </div>
              </div>
            </div>
            {/* 中獎清單 */}
            <div className="winning-list">
              <div className="winning-list__header">
                <div className="winning-list__title">{this.state.prizeWinnerInfo.DRAW_TEXT}</div>
                <div className="winning-list__period">
                  <span>{`抽獎日期：${moment(this.state.prizeWinnerInfo.DRAW_DATE).format('YYYY/MM/DD')}`}</span>
                </div>
              </div>
              <table className="element__table-horizon">
                <tbody>
                  {
                    handleCreatePrizeArea(this.state.prizeWinnerInfo)
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {/* 頁面導航控制項 */}
        <PageNavControls
          prevBtnLink="/"
          onPrevClick={() => handleNextPrevClick(this.state.prizeWinnerInfo?.PREV_SN || 0)}
          nextBtnLink="/"
          onNextClick={() => handleNextPrevClick(this.state.prizeWinnerInfo?.NEXT_SN || 0)}
          navBtnLink={RouterSettings.Promotions.List}
          navBtnText={`回${this.state.prePromotionTitle}頁`}
          onRefresh={() => handleNextPrevClick(this.state.prizeWinnerInfo?.SN || 0)}
          prevSN={this.state.prizeWinnerInfo?.PREV_SN || 0}
          nextSN={this.state.prizeWinnerInfo?.NEXT_SN || 0}
        />
      </div>
    );
  }
};

export default PromotionsAnnouncement;
